// extracted by mini-css-extract-plugin
export var tosLink = "_ax-0";